/* istanbul ignore file */
import { ClientEvent } from '@udemy/event-tracking';
/**
 * Fired when a user is presented with a testimonial
 */
export class TestimonialImpressionEvent extends ClientEvent {
  constructor({
    id,
    type,
    uiRegion
  }) {
    super('TestimonialImpressionEvent');
    this.id = void 0;
    this.type = void 0;
    this.uiRegion = void 0;
    this.id = id;
    this.type = type;
    this.uiRegion = uiRegion;
  }
}

/**
 * Fired when a user clicks on a link in the testimonial
 */
export class TestimonialClickEvent extends ClientEvent {
  constructor({
    id,
    type,
    uiRegion,
    url = null
  }) {
    super('TestimonialClickEvent');
    this.id = void 0;
    this.type = void 0;
    this.url = void 0;
    this.uiRegion = void 0;
    this.id = id;
    this.type = type;
    this.uiRegion = uiRegion;
    this.url = url;
  }
}
//# sourceMappingURL=events.js.map